import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCartStore, useAuthStore } from '../store';
import { toast } from 'react-toastify';
import './Cart.css';

export default function Cart() {
  const { items, updateItem, removeItem, clearCart } = useCartStore();
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const shipping  = subtotal >= 150 ? 0 : subtotal > 0 ? 9.99 : 0;
  const total     = subtotal + shipping;
  const toFree    = 150 - subtotal;

  const handleCheckout = () => {
    if (!isAuthenticated) { toast.info('Please login to checkout'); navigate('/login', { state: { from: '/checkout' } }); return; }
    navigate('/checkout');
  };

  if (items.length === 0) return (
    <div className="cart-empty">
      <div className="cart-empty__inner">
        <div className="cart-empty__icon">🛒</div>
        <h2>Your cart is empty</h2>
        <p>Add some research compounds to get started.</p>
        <Link to="/shop" className="btn btn-primary btn-lg">Browse Products</Link>
      </div>
    </div>
  );

  return (
    <div className="container cart-page">
      <h1 className="cart-title">Shopping Cart <span>({items.length} {items.length === 1 ? 'item' : 'items'})</span></h1>

      {toFree > 0 && (
        <div className="free-shipping-bar">
          🚚 Add <strong>${toFree.toFixed(2)}</strong> more for FREE shipping!
          <div className="free-bar"><div className="free-bar__fill" style={{ width: `${(subtotal / 150) * 100}%` }} /></div>
        </div>
      )}
      {subtotal >= 150 && <div className="free-shipping-bar success">✅ You qualify for FREE shipping!</div>}

      <div className="cart-layout">
        {/* Items */}
        <div className="cart-items">
          {items.map(item => (
            <div key={item.key} className="cart-item card">
              <img src={item.image || 'https://placehold.co/80x80?text=P'} alt={item.name} className="cart-item__img" />
              <div className="cart-item__info">
                <h3>{item.name}</h3>
                {item.variant && <p className="cart-item__variant">{item.variant}</p>}
                <p className="cart-item__price">${item.price.toFixed(2)} each</p>
              </div>
              <div className="cart-item__qty">
                <button onClick={() => updateItem(item.key, item.quantity - 1)}>−</button>
                <span>{item.quantity}</span>
                <button onClick={() => updateItem(item.key, item.quantity + 1)}>+</button>
              </div>
              <div className="cart-item__subtotal">${(item.price * item.quantity).toFixed(2)}</div>
              <button className="cart-item__remove" onClick={() => { removeItem(item.key); toast.info('Item removed'); }}>✕</button>
            </div>
          ))}
          <div className="cart-actions">
            <Link to="/shop" className="btn btn-secondary">← Continue Shopping</Link>
            <button className="btn btn-danger btn-sm" onClick={() => { clearCart(); toast.info('Cart cleared'); }}>Clear Cart</button>
          </div>
        </div>

        {/* Summary */}
        <div className="cart-summary card">
          <h3>Order Summary</h3>
          <div className="summary-row"><span>Subtotal</span><strong>${subtotal.toFixed(2)}</strong></div>
          <div className="summary-row"><span>Shipping</span><strong>{shipping === 0 ? 'FREE' : `$${shipping.toFixed(2)}`}</strong></div>
          <hr className="divider" />
          <div className="summary-row summary-total"><span>Total</span><strong>${total.toFixed(2)}</strong></div>
          <button className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: '1.25rem' }} onClick={handleCheckout}>
            Proceed to Checkout →
          </button>
          <div className="summary-trust">
            <span>🔒 SSL Secured</span>
            <span>↩️ Easy Returns</span>
            <span>🏆 Verified Quality</span>
          </div>
        </div>
      </div>
    </div>
  );
}
